/** Shared with `signUpMobileValidation` — keep messages identical. */
export const phoneDigitLengthMessage = 'Phone number must be between 10 and 15 digits'

export const formValidation = {
  organizationName: {
    minLength: {
      value: 2,
      message: 'Organization name must be at least 2 characters',
    },
    maxLength: {
      value: 100,
      message: 'Organization name must be less than 100 characters',
    },
  },
  websiteUrl: {
    validate: (value: string) => {
      if (!value || !value.trim()) return true // Optional field
      try {
        const url =
          value.startsWith('http://') || value.startsWith('https://') ? value : `https://${value}`
        new URL(url)
        return true
      } catch {
        return 'Please enter a valid URL (e.g., https://example.com)'
      }
    },
  },
  shortDescription: {
    maxLength: {
      value: 200,
      message: 'Short description must be less than 200 characters',
    },
  },
  organizationDescription: {
    minLength: {
      value: 50,
      message: 'Description must be at least 50 characters',
    },
    maxLength: {
      value: 2000,
      message: 'Description must be less than 2000 characters',
    },
  },
  firstName: {
    minLength: {
      value: 2,
      message: 'First name must be at least 2 characters',
    },
    maxLength: {
      value: 50,
      message: 'First name must be less than 50 characters',
    },
    pattern: {
      value: /^[a-zA-Z\s'-]+$/,
      message: 'First name can only contain letters, spaces, hyphens, and apostrophes',
    },
  },
  lastName: {
    minLength: {
      value: 2,
      message: 'Last name must be at least 2 characters',
    },
    maxLength: {
      value: 50,
      message: 'Last name must be less than 50 characters',
    },
    pattern: {
      value: /^[a-zA-Z\s'-]+$/,
      message: 'Last name can only contain letters, spaces, hyphens, and apostrophes',
    },
  },
  email: {
    pattern: {
      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
      message: 'Please enter a valid email address',
    },
  },
  phone: {
    pattern: {
      value: /^[\d\s\-\+\(\)]+$/,
      message: 'Please enter a valid phone number',
    },
    validate: (value: string) => {
      if (!value) return true // Optional field
      // Remove common phone formatting characters
      const digitsOnly = value.replace(/[\s\-\(\)\+]/g, '')
      if (digitsOnly.length < 10 || digitsOnly.length > 15) {
        return phoneDigitLengthMessage
      }
      return true
    },
  },
  relationToOrganization: {
    maxLength: {
      value: 200,
      message: 'Relation to organization must be less than 200 characters',
    },
  },
  date: {
    required: {
      value: true,
      message: 'Date is required',
    },
    validate: (value: Date) => {
      if (!value) return true // Optional field
      if (value > new Date()) {
        return 'Date cannot be in the future'
      }
      return true
    },
  },
  zipCode: {
    pattern: {
      value: /^[0-9]{5}$/,
      message: 'Please enter a valid zip code',
    },
  },
  organizationNonprofitAdvocacyVerification: {
    validate: (value: string) => {
      if (value === 'yes') {
        return true
      }
      return 'Only nonprofit or advocacy organizations are eligible to be featured'
    },
  },
}
